import { Link } from 'react-router-dom';
import LiveStatusPill from './LiveStatusPill.jsx';
import DjSocialLinks, { getDjDisplayName } from './DjSocialLinks.jsx';

export default function EventHeader({
  event,
  liveStatus,
  participants,
  displayName,
  accountLoading,
  onOpenAccount,
  stats,
  liveBoostFeed = [],
  paidQueueUiEnabled = true,
}) {
  const barName = event?.establishments?.name ?? 'Bar';
  const djName = getDjDisplayName(event?.djs);

  const accountLabel = accountLoading
    ? 'Connexion…'
    : displayName
      ? displayName
      : 'Compte';

  return (
    <header className="card-raised relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-16 -top-20 h-48 w-48 rounded-full bg-accent/20 blur-3xl"
      />
      <div className="relative flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <LiveStatusPill status={liveStatus} participants={participants} />
          <h1 className="font-display mt-1.5 text-2xl font-bold leading-tight tracking-tight [overflow-wrap:anywhere]">
            {event?.name ?? 'Soirée'}
          </h1>
          <p className="mt-0.5 truncate text-sm text-white/65">
            {barName}
            {djName ? (
              <>
                <span className="text-white/30"> · </span>DJ {djName}
              </>
            ) : null}
          </p>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <Link
            to="/"
            aria-label="Accueil — changer de soirée"
            title="Changer de soirée"
            className="btn-ghost flex min-h-[44px] items-center rounded-xl border border-border bg-bg-soft px-3 py-2"
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 11l9-8 9 8" />
              <path d="M5 10v10h14V10" />
            </svg>
          </Link>
          <button
            type="button"
            onClick={onOpenAccount}
            aria-label={accountLoading ? 'Connexion en cours' : `Compte : ${accountLabel}`}
            className="btn-ghost min-h-[44px] max-w-[5.5rem] rounded-xl border border-border bg-bg-soft px-3 py-2 text-xs font-semibold"
          >
            <span className="min-w-0 truncate">{accountLabel}</span>
          </button>
        </div>
      </div>

      {stats ? (
        <p className="mt-3 text-xs leading-relaxed text-white/55">
          <span className="font-mono font-semibold tabular-nums text-white/85">{stats.total}</span> suggestion
          {stats.total !== 1 ? 's' : ''}
          {paidQueueUiEnabled ? (
            <>
              {' '}
              · pot{' '}
              <span className="font-mono font-semibold tabular-nums text-gold">{stats.tipsLabel}</span>
              {' '}
              ·{' '}
              <span className="font-mono font-semibold tabular-nums text-white/75">{stats.boosted}</span> avec montant
            </>
          ) : (
            <>
              {' '}
              ·{' '}
              <span className="font-mono font-semibold tabular-nums text-white/75">
                {Number.isFinite(participants) ? participants : 0}
              </span>{' '}
              connecté{participants === 1 ? '' : 's'}
            </>
          )}
        </p>
      ) : null}

      {djName ? (
        <div className="mt-3 flex flex-col gap-2 border-t border-border pt-3">
          <p className="text-[11px] leading-snug text-white/55">
            Aux platines : <span className="font-semibold text-white/85">{djName}</span>
          </p>
          <DjSocialLinks dj={event?.djs} compact />
        </div>
      ) : null}

      {paidQueueUiEnabled && liveBoostFeed.length > 0 ? (
        <div className="mt-3 rounded-xl border border-border bg-bg-soft/80 px-3 py-2.5">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-white/45">
            En direct
          </p>
          <ul className="mt-1 max-h-[4.5rem] space-y-0.5 overflow-hidden text-[11px] leading-snug text-white/75">
            {liveBoostFeed.slice(0, 3).map((item) => (
              <li key={item.id} className="truncate">
                {item.line}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </header>
  );
}
